
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import './PrivateFooterComponent.scss'

interface PrivateFooterComponentProps {}

const PrivateFooterComponent = (props: PrivateFooterComponentProps) : JSX.Element => {
    const appConfig = useAppConfig();
    return (
        <div className="private-footer-component">
          {appConfig.config.chainName  ?? "Beds2B"}
        </div>
    )
}

export default PrivateFooterComponent;